import { Badge } from 'framework7-react';
import { useEffect } from 'react';

import {
  useCurrentEntertainerMetricsQuery,
  useCurrentEntertainerQuery,
} from '@queries/EntertainerQueries';

import { useAnalytics } from '@hooks/useAnalytics';

import { useNavigate } from '@router/index';

import IconButton from '@components/buttons/IconButton';
import { Chip } from '@components/chips/Chip';
import { FontAwesomeIcon } from '@components/icons/FontAwesomeIcon';
import Card from '@components/layout/Card/Card';

export const MetricsSectionCard = () => {
  const { track } = useAnalytics();
  const navigate = useNavigate();
  const { entertainerMetrics, refetchEntertainerMetrics } = useCurrentEntertainerMetricsQuery();

  const entertainerMetricsSection = entertainerMetrics?.metricsSection;

  useEffect(() => {
    refetchEntertainerMetrics();
  }, []);

  return (
    <Card indicator={entertainerMetrics?.metricsSection?.indicatorCount}>
      <div>
        <div className="d-flex gap-2 align-items-center" style={{ padding: '8px 12px 0px 12px' }}>
          <FontAwesomeIcon name="chart-line" />
          <strong className="fs-6">{entertainerMetricsSection?.title}</strong>
          <div className="ml-auto">
            <IconButton
              size="sm"
              color="neutral"
              variant="smooth"
              onClick={() => {
                track('Click Entertainer Metrics Card');
                navigate(`/manage/entertainer/metrics`);
              }}
            >
              <FontAwesomeIcon name="chevron-right" />
            </IconButton>
          </div>
        </div>
        <div className="d-grid gap-1 mt-2" style={{ padding: '0px 4px 8px 4px' }}>
          {entertainerMetricsSection?.content?.map(
            ({ style, label, value, trendDirection, hideValue = false }) => (
              <div
                key={`${label}-${value}`}
                className="py-1 px-2"
                style={{ background: 'rgba(0,0,0,.25)', borderRadius: 6, ...style }}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <div className="me-2">
                    <strong>{label}</strong>
                  </div>
                  {!hideValue && (
                    <>
                      <span className="ml-auto">{value}</span>
                      <div className="ms-1">
                        <div
                          className={trendDirection === 'up' ? 'color-green' : 'color-red'}
                          style={{
                            opacity: trendDirection ? 1 : 0,
                            color: 'var(--f7-theme-color)',
                          }}
                        >
                          <FontAwesomeIcon
                            name={trendDirection === 'up' ? 'caret-up' : 'caret-down'}
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            ),
          )}
        </div>
      </div>
    </Card>
  );
};
